import axios from '@/http/index';

const base = '';
// 获得一个顾客信息详情
export const getOneCustomerMsg = (params) => axios.get(`${base}/erp/customer/getOneCustomerMsg`, params).then((res) => res.data);
// 获得预约列表
export const getBookOrderList = (params) => axios.get(`${base}/erp/customer/getBookOrderList`, params).then((res) => res.data);
// 取消预约
export const getBookFailures = (param) => axios.get(`${base}/erp/bookOrder/bookFailures`, param).then((res) => res.data);
// 获得单个顾客消费记录列表
export const getExpenseListByPhone = (param) => axios.get(`${base}/erp/customer/getExpenseListByPhone`, param).then((res) => res.data);
// 获得顾客单个消费记录明细(服务开单)
export const getOneExpenseMsg4Serve = (param) => axios.get(`${base}/erp/customer/getOneExpenseMsg4Serve`, param).then((res) => res.data);
// 获得顾客单个消费记录明细(美容套餐)
export const getOneExpenseMsg4Package = (param) => axios.get(`${base}/erp/customer/getOneExpenseMsg4Package`, param).then((res) => res.data);
// 获得单个顾客套餐划扣记录列表
export const getPackageUseListByPhone = (param) => axios.get(`${base}/erp/customer/getPackageUseListByPhone`, param).then((res) => res.data);
// 获得单个顾客单个套餐划扣记录详情
export const getOnePackageUseDetailByPhone = (param) => axios.get(`${base}/erp/customer/getOnePackageUseDetailByPhone`, param).then((res) => res.data);
// 查询会员套餐订单记录
export const getBeautyPackageList = (params) => axios.get(`${base}/erp/customer/getBeautyPackageList`, params).then((res) => res.data);
// 会员套餐划扣--选择扫码支付
export const postDeductCardCount = (params) => axios.post(`${base}/erp/lookVipCard/updateClientVipCardItem`, params).then((res) => res.data);
// 获得会员套餐客户信息
export const getUserCardInfo = (params) => axios.get(`${base}/erp/lookVipCard/selectClientVipCardInfo`, params).then((res) => res.data);
// 打印订单
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);

// (4.1订单详情)获得服务开单订单详情
export const getOrderDetail4AllDto = (param) => axios.get(`${base}/erp/customerOrder/getOrderDetail4AllDto`, param).then((res) => res.data);
// (4.3)查询单个顾客单个美容套餐划扣记录
export const getOneBeautyPackageDeductList = (param) => axios.get(`${base}/erp/customer/getOneBeautyPackageDeductList`, param).then((res) => res.data);
// 4.4.0待确认状态  确认和拒绝事件  确认是1或取消是0
export const getSureOrFalse = (param) => axios.get(`${base}/busmanage/booksOrder/getSureOrFalse`, param).then((res) => res.data);
// 5.3顾客-房间列表与详情
export const getCustomerRoom = (param) => axios.get(`${base}/erp/lookBookRoom/getCustomerRoom`, param).then((res) => res.data);
// 5.4获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);

// (5.6)查询客户单个套餐使用详情
export const getOneClientVipCardUseMsg = (param) => axios.get(`${base}/erp/lookVipCard/getOneClientVipCardUseMsg`, param).then((res) => res.data);

// 6.2 顾客赠品列表信息
export const clientGifts = (param) => axios.get(`${base}/erp/customer/clientGifts`, param).then((res) => res.data);

// （6.7）(6.7)获取会员可划扣详情
export const getDeductDetails = (params) => axios.get(`${base}/erp/customerOrder/getDeductDetails`, params).then((res) => res.data);

// 6.6获取预约订单详情
export const getBookOrderDetail = (params) => axios.get(`${base}/erp/bookOrder/getBookOrderDetail`, params).then((res) => res.data);

// （5.6）预约订单取消提示
export const getBookCancelMsg = (param) => axios.get(`${base}/erp/bookOrder/getBookCancelMsg`, param).then((res) => res.data);
